// Comprehensive car brands, models, and colors for Car Dealer Portal

export const CAR_BRANDS = [
  'Aston Martin', 'Audi', 'Bentley', 'BMW', 'Bugatti', 'Cadillac', 'Chevrolet', 
  'Ferrari', 'Ford', 'Genesis', 'Honda', 'Jaguar', 'Koenigsegg', 'Lamborghini', 
  'Land Rover', 'Lexus', 'Lotus', 'Maserati', 'Maybach', 'McLaren', 'Mercedes-Benz', 
  'Nissan', 'Pagani', 'Porsche', 'Rimac', 'Rolls-Royce', 'Tesla', 'Toyota'
];

export const CAR_MODELS = {
  'Aston Martin': ['DB11', 'DB12', 'DBS Superleggera', 'Vantage', 'DBX', 'DBX707', 'Valkyrie', 'Valhalla'],
  'Audi': ['A4', 'A6', 'A8', 'Q5', 'Q7', 'Q8', 'RS6 Avant', 'RS7', 'RS Q8', 'R8', 'e-tron GT', 'RS e-tron GT'],
  'Bentley': ['Continental GT', 'Continental GTC', 'Flying Spur', 'Bentayga', 'Bentayga EWB', 'Mulliner Batur'],
  'BMW': ['3 Series', '5 Series', '7 Series', 'X3', 'X5', 'X6', 'X7', 'XM', 'M3', 'M4', 'M5', 'M8', 'i4', 'i7', 'iX'],
  'Bugatti': ['Chiron', 'Chiron Sport', 'Chiron Super Sport', 'Chiron Pur Sport', 'Divo', 'Bolide', 'Mistral', 'Tourbillon'],
  'Cadillac': ['Escalade', 'Escalade V', 'CT5-V Blackwing', 'Lyriq', 'Celestiq'],
  'Chevrolet': ['Corvette Stingray', 'Corvette Z06', 'Corvette E-Ray', 'Camaro ZL1', 'Tahoe', 'Suburban'],
  'Ferrari': ['296 GTB', '296 GTS', 'Roma', 'Roma Spider', 'Portofino M', 'SF90 Stradale', 'SF90 Spider', '812 Competizione', 'Purosangue', 'Daytona SP3', 'F8 Tributo', 'F8 Spider'],
  'Ford': ['Mustang GT', 'Mustang Dark Horse', 'Mustang Mach-E', 'F-150 Raptor', 'Bronco Raptor', 'GT'],
  'Genesis': ['G70', 'G80', 'G90', 'GV60', 'GV70', 'GV80'],
  'Honda': ['Civic Type R', 'Accord', 'Pilot', 'CR-V'],
  'Jaguar': ['F-TYPE', 'F-PACE', 'F-PACE SVR', 'I-PACE', 'XF'],
  'Koenigsegg': ['Jesko', 'Jesko Absolut', 'Gemera', 'Regera', 'CC850'],
  'Lamborghini': ['Huracán EVO', 'Huracán STO', 'Huracán Tecnica', 'Huracán Sterrato', 'Revuelto', 'Urus', 'Urus Performante', 'Urus SE'],
  'Land Rover': ['Range Rover', 'Range Rover Sport', 'Range Rover Sport SV', 'Defender 90', 'Defender 110', 'Defender 130'],
  'Lexus': ['LC 500', 'LC 500h', 'LS 500', 'LX 600', 'RX 500h', 'LBX'],
  'Lotus': ['Emira', 'Evija', 'Eletre', 'Emeya'],
  'Maserati': ['MC20', 'MC20 Cielo', 'GranTurismo', 'GranCabrio', 'Grecale', 'Levante'],
  'Maybach': ['S 580', 'S 680', 'GLS 600', 'EQS SUV'],
  'McLaren': ['720S', '720S Spider', '765LT', '765LT Spider', 'Artura', 'Artura Spider', 'GT', '750S', '750S Spider', 'Solus GT'],
  'Mercedes-Benz': ['A-Class', 'C-Class', 'E-Class', 'S-Class', 'Maybach S-Class', 'AMG GT', 'AMG GT 63', 'AMG SL', 'G-Class', 'AMG G 63', 'GLE', 'GLS', 'Maybach GLS', 'EQS', 'EQE', 'AMG ONE'],
  'Nissan': ['GT-R', 'GT-R Nismo', 'Z', 'Patrol', 'Armada'],
  'Pagani': ['Huayra', 'Huayra Roadster', 'Huayra R', 'Utopia', 'Utopia Roadster'],
  'Porsche': ['911 Carrera', '911 Carrera S', '911 Turbo', '911 Turbo S', '911 GT3', '911 GT3 RS', '911 Dakar', '718 Cayman GT4', '718 Spyder', 'Taycan', 'Taycan Turbo S', 'Cayenne', 'Cayenne Turbo GT', 'Panamera', 'Macan'],
  'Rimac': ['Nevera', 'Nevera R'],
  'Rolls-Royce': ['Phantom', 'Phantom Extended', 'Ghost', 'Ghost Extended', 'Wraith', 'Dawn', 'Cullinan', 'Cullinan Black Badge', 'Spectre'],
  'Tesla': ['Model S', 'Model S Plaid', 'Model 3', 'Model X', 'Model X Plaid', 'Model Y', 'Cybertruck', 'Roadster'],
  'Toyota': ['Supra', 'GR86', 'Land Cruiser', 'Century']
};

export const CAR_COLORS = [
  { name: 'Arctic White', hex: '#FFFFFF' },
  { name: 'Obsidian Black', hex: '#0A0A0A' },
  { name: 'Midnight Blue', hex: '#191970' },
  { name: 'British Racing Green', hex: '#004225' },
  { name: 'Rosso Corsa (Ferrari Red)', hex: '#D40000' },
  { name: 'Giallo Modena (Ferrari Yellow)', hex: '#FFCC00' },
  { name: 'Arancio Argos (Orange)', hex: '#FF6600' },
  { name: 'Grigio Telesto (Grey)', hex: '#808080' },
  { name: 'Viola Parsifae (Purple)', hex: '#8B008B' },
  { name: 'Blu Corsa (Blue)', hex: '#003399' },
  { name: 'Verde Mantis (Green)', hex: '#228B22' },
  { name: 'Bianco Monocerus (Pearl White)', hex: '#F5F5F5' },
  { name: 'Nero Pegaso (Matte Black)', hex: '#1C1C1C' },
  { name: 'Rosso Efesto (Dark Red)', hex: '#8B0000' },
  { name: 'Champagne', hex: '#F7E7CE' },
  { name: 'Bronze', hex: '#CD7F32' },
  { name: 'Silver Arrow', hex: '#C0C0C0' },
  { name: 'Moonlight Silver', hex: '#D3D3D3' },
  { name: 'Graphite', hex: '#383838' },
  { name: 'Nardo Grey', hex: '#6D6E71' },
  { name: 'Python Green', hex: '#4A5D23' },
  { name: 'Miami Blue', hex: '#00B4D8' },
  { name: 'Chalk', hex: '#E8E8E8' },
  { name: 'Guards Red', hex: '#CC0000' },
  { name: 'Racing Yellow', hex: '#FFD700' },
  { name: 'Frozen Berry', hex: '#8E4585' },
  { name: 'Tanzanite Blue', hex: '#1D1F3F' },
  { name: 'Java Green', hex: '#1E3D2F' }
];

export const CAR_CONDITIONS = [
  { id: 'new', label: 'Brand New' },
  { id: 'certified', label: 'Certified Pre-Owned' },
  { id: 'used', label: 'Used' },
  { id: 'classic', label: 'Classic/Vintage' }
];

export const CAR_YEARS = Array.from({ length: 30 }, (_, i) => new Date().getFullYear() + 1 - i);
